import { RedoTextInput } from "@redotech/arbiter/input/redo-text-input";
import { InputSchema, groupInput, input } from "@redotech/ui/form";
import { nonEmptyValidator } from "@redotech/ui/validators";
import { memo } from "react";

export const JitsuCarrierInput = groupInput({
  apiKey: input<string>({ validator: nonEmptyValidator }),
});

export type JitsuCarrierValue = InputSchema.Value<typeof JitsuCarrierInput>;

export type JitsuCarrierForm = InputSchema.Input<typeof JitsuCarrierInput>;

export const jitsuCarrierDefault = (): JitsuCarrierValue => ({ apiKey: "" });

export const CreateJitsuCarrierForm = memo(function CreateJitsuCarrierForm({
  carrierInput,
}: {
  carrierInput: JitsuCarrierForm;
}) {
  return (
    <RedoTextInput
      inputTypeHint="password"
      label="API token"
      placeholder=""
      setValue={carrierInput.inputs.apiKey.setValue}
      value={carrierInput.inputs.apiKey.value}
    />
  );
});
